//react/redux
import { HiQuestionMarkCircle } from "react-icons/hi2";
import { datadogLogs } from "@datadog/browser-logs";

//components
import Header from "../Common/header";
import { useEffect } from "react";

const Unknown = ({
    tenantColor,
    tenantImage,
    tenantName,
    responseScan,
    token,
}) => {
    datadogLogs.logger.info(
        `Process unknown with the invitationId: ${responseScan?.invitation_id}`,
        {
            invitationId: responseScan?.invitation_id,
            tenantName: tenantName,
            //url: responsePayload?.ScanProcess?.url,
        }
    );

    useEffect(() => {
        setTimeout(() => {
            if (responseScan?.redirect) {
                window.location.href = `/setup?token=${token}`;
            }
        }, 7000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <section className="container mx-auto flex flex-col items-center justify-start gap-5">
                <Header
                    responseScan={responseScan}
                    tenantColor={tenantColor}
                    tenantImage={tenantImage}
                    tenantName={tenantName}
                />
                <div className="px-4 py-24 flex flex-col justify-center items-center gap-4 my-3">
                    <HiQuestionMarkCircle size={120} className="text-primary-error" />
                    <h2 className="text-2xl">Unknown</h2>
                    <p className="text-center text-sm">
                        The process was not completed. Please contact
                        support for more information.
                    </p>
                </div>
            </section>
        </>
    );
};

export default Unknown;
